import GameOverView from "./view";
import { makeTimeString } from "core/util";
import calculateScore from "core/score";
import Gamepad, { Event } from "core/gamepad";
import ExitByGamepadController from "./controller/exitByGamepadController";
export default function GameOverScreen(element) {
  const view = GameOverView(element);
  async function show(result) {
    const analyzedResult = analyzeResult(result);
    await view.updateHighscore(analyzedResult);
    const score = calculateScore(analyzedResult);
    const {
      timeMillis,
      starsCount
    } = analyzedResult;
    const timeString = makeTimeString(timeMillis);
    view.setTime(timeString);
    view.setStars(starsCount, 8);
    view.setScore(score);
    view.setThanksVisible(false);
    view.setThanksVisible(true);
    const exitByGamepadController = ExitByGamepadController(view);
    Gamepad.on(Event.ButtonDown, exitByGamepadController);
    const res = await view.execute();
    Gamepad.off(Event.ButtonDown, exitByGamepadController);
    return res;
  }
  function analyzeResult(result) {
    const timeMillis = result.timeEnded - result.timeStarted;
    const starsCount = "star.png" in result.player.items ? result.player.items["star.png"] : 0;
    return {
      timeMillis,
      starsCount
    };
  }
  return Object.assign(view, {
    show
  });
}